import firebase from "firebase/app";
import "firebase/firestore";
// You need to enter your own API keys here like I have shown in the video
// const firebaseConfig = {
//   apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
//   authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
//   projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
//   storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
//   messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
//   appId: process.env.REACT_APP_FIREBASE_APP_ID,
// };
// config of hyptar-ag
// const firebaseConfig = {
//   apiKey: "AIzaSyBYmvsg0VP6yVi0TKtekr6oZjyctlVlWn8",
//   authDomain: "hyptar-ag.firebaseapp.com",
//   projectId: "hyptar-ag",
//   storageBucket: "hyptar-ag.appspot.com",
//   messagingSenderId: "289675993419",
//   appId: "1:289675993419:web:a76bf41dc5ab2fb97f08ce",
//   measurementId: "G-NH010W70SG",
// };
const firebaseConfig = {
  apiKey: "AIzaSyDQe1mrIdGzByE0qUT8vRtJ3XXRNqxbabM",
  authDomain: "hyptar-subscribe.firebaseapp.com",
  projectId: "hyptar-subscribe",
  storageBucket: "hyptar-subscribe.appspot.com",
  messagingSenderId: "233275111794",
  appId: "1:233275111794:web:54d74b2d842fb8f92545eb",
  measurementId: "G-ET5LYLQY8N",
};

const firebaseApp = firebase.initializeApp(firebaseConfig);
const db = firebaseApp.firestore();
export default db;
